import React from 'react'

type TTips = {
  readonly title: string
  readonly tipsList: string[]
}

export default function Tips({ title, tipsList }: TTips) {
  return (
    <div className='flex w-full flex-col gap-2 rounded-lg bg-pop-alert-background px-4 py-3'>
      <span className='text-sm-bold text-neutral-grey-800'>{title}</span>
      <ul className='list-disc pl-4 text-sm-regular text-neutral-grey-800'>
        {tipsList?.length > 0 && tipsList?.map((val) => <li key={val}>{val}</li>)}
      </ul>
    </div>
  )
}
